import { object, string } from 'yup';

import { createValidator } from '@src/validation';

export const querySystemDrawerSchema = object().shape({
  year: string().nullable().required(),
  periodCode: string().nullable().required(),
  organizationCode: string().nullable().required(),
  reportGroupCode: string().nullable().required(),
  correction: string()
    .nullable()
    .matches(/\S/, 'Корректировка не должна состоять из пробелов')
    .matches(/^\S.*$/gm, 'Корректировка не должна начинаться с пробела')
    .required(),
});

export const validate = createValidator(querySystemDrawerSchema);
